export default "__VITE_ASSET__D_928XUy__"